import Page from 'src/components/page/page';
import useLpEventsDetails from './lp-events-details.hook';
import { Box, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import CNLoading from 'src/components/loading-cn/CNLoading';
import LpEventsForm from './components/lp-events-form';

export default function LpEventsDetails() {
  const {
    isEdit,
    methods,
    control,
    isSubmitting,
    isLoadingLpEventDetails,
    businessUnits,
    STATUS_LABEL,
    STATUS_OPTIONS,
    formValues,
    handleDropBannerImage,
    handleDropContentImage,
    handleDropRegisterPageBannerImage,
    handleDropRegisterPageContentImage,
    handleDropHomePageBannerImage,
    onSubmit,
    navigate,
  } = useLpEventsDetails();

  return (
    <Page title={isEdit ? 'Editar Evento LP' : 'Cadastrar Evento LP'}>
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading={isEdit ? 'Editar Evento LP' : 'Cadastrar Evento LP'}
          links={[]}
        />
        {isLoadingLpEventDetails ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <LpEventsForm
            formValues={formValues}
            methods={methods}
            control={control}
            isEdit={isEdit}
            isSubmitting={isSubmitting}
            businessUnits={businessUnits}
            onSubmit={onSubmit}
            navigate={navigate}
            handleDropBannerImage={handleDropBannerImage}
            handleDropContentImage={handleDropContentImage}
            handleDropRegisterPageBannerImage={handleDropRegisterPageBannerImage}
            handleDropRegisterPageContentImage={handleDropRegisterPageContentImage}
            handleDropHomePageBannerImage={handleDropHomePageBannerImage}
            stautsOptions={STATUS_OPTIONS}
            statusLabel={STATUS_LABEL}
          />
        )}
      </Container>
    </Page>
  );
}
